import { render, staticRenderFns } from "./AdminContentCard.vue?vue&type=template&id=1c1c9470"
import script from "./AdminContentCard.vue?vue&type=script&lang=js"
export * from "./AdminContentCard.vue?vue&type=script&lang=js"
import style0 from "./AdminContentCard.vue?vue&type=style&index=0&id=1c1c9470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports